export interface Steps {
  index: string;
  name: string;
  description: string;
}

export enum UserDialogView {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_UPDATE = 'RESET_UPDATE',
  MOBILE_MENU = 'MOBILE_MENU',
  CLOSE = 'CLOSE',
}
